export default "__VITE_ASSET__CejjtOi2__"